import { GetterTree } from "vuex";
import { FirestoreState } from "./types";
import { RootState } from "@/store/types";

export const getters: GetterTree<FirestoreState, RootState> = {};
